module.exports = __webpack_public_path__ + "static/desktop/img/child.92781a21.png";